import { getAuth, signOut as firebaseSignout } from "firebase/auth";
import * as Sentry from "@sentry/browser";
import { isMyAppWKWebView } from "./isMyAppWKWebView";


export async function signOut() {
  if (window.Android) {
    return window.Android.signOut();
  }

  if (isMyAppWKWebView()) {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    return (window.webkit as any).messageHandlers.signOut.postMessage(undefined);
  }

  return signOutWebBridge();
}

async function signOutWebBridge(): Promise<{ error: string | null }> {
  try {
      const auth = getAuth();
      await firebaseSignout(auth);
      return { error: null };
  } catch (error: unknown) {
      const errorMessage = error instanceof Error ? error.message : "An unknown error occurred";
      Sentry.captureException(error);
      return { error: errorMessage };
  }
}
